export default "__VITE_ASSET__C7M0Le90__"